import validator from 'jquery-validation';
import addMethods from 'jquery-validation/dist/additional-methods';

validator;
addMethods;

jQuery.validator.setDefaults({
    onFocusOut: true,
    errorClass: 'input-error',
    errorElement: 'span',
    errorLabelContainer: '.form-errors',
    errorPlacement: function (error, element) {
        element.next('span').remove();
        error.insertAfter(element).removeClass('field-validation-error').addClass('ui-state-error');

        if (element.is(':checkbox')) {
            error.addClass('error-check');
        }
    },
    invalidHandler: function (event, validator) {
        const elemForm = $(event.currentTarget);

        elemForm.find("button[type='submit']").removeClass('loading');
        elemForm.find('.form-feedback').empty();

        const actionCaptcha = elemForm.find('.input-captcha').data('action');
        reloadCaptcha(actionCaptcha);
    },
    submitHandler: function (form) {
        const button = $(form).find('button[type=submit]');
        if (button.hasClass('loading')) {
            return;
        }

        button.addClass('loading');

        form.submit();
    },
});

// console.log(data);
//const elemForm = $(element).closest('form');
//elemForm[0].reset();
//elemForm.find("button[type='submit']").removeClass('loading');
//elemForm.find('.form-feedback').html(data);
